module.exports = "<uch></uch>\r\n<shop-list params='step:\"list\"'></shop-list>";


//////////////////
// WEBPACK FOOTER
// ./src/component/shopList/shopListIndex.html
// module id = 188
// module chunks = 0